/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { ErrorType } from '../../axios';
import { request } from '../../axios';
import type { PaginatedResponse } from '../pagination/pagination.types';
import type {
  GetPatientsSummaryParams,
  GetTracingContactSummaryParams,
  PatientSummaryDto,
  TracingContactSummaryDto,
} from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const getTracingContactSummary = (
  params?: GetTracingContactSummaryParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PaginatedResponse<TracingContactSummaryDto>>(
    { url: `/api/summary/tracing-contacts`, method: 'GET', params, signal },
    options,
  );
};

export const getGetTracingContactSummaryQueryKey = (params?: GetTracingContactSummaryParams) => {
  return [`/api/summary/tracing-contacts`, ...(params ? [params] : [])] as const;
};

export const getGetTracingContactSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContactSummary>>> = ({ signal }) =>
    getTracingContactSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTracingContactSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getTracingContactSummary>>>;
export type GetTracingContactSummaryQueryError = ErrorType<unknown>;

export function useGetTracingContactSummary<
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetTracingContactSummaryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactSummary<
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactSummary<
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContactSummary<
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTracingContactSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactSummaryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContactSummary>>> = ({ signal }) =>
    getTracingContactSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTracingContactSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTracingContactSummary>>
>;
export type GetTracingContactSummarySuspenseQueryError = ErrorType<unknown>;

export function useGetTracingContactSummarySuspense<
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetTracingContactSummaryParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactSummarySuspense<
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactSummaryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactSummarySuspense<
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactSummaryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContactSummarySuspense<
  TData = Awaited<ReturnType<typeof getTracingContactSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactSummaryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactSummarySuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPatientsSummary = (
  params?: GetPatientsSummaryParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PaginatedResponse<PatientSummaryDto>>(
    { url: `/api/summary/patients`, method: 'GET', params, signal },
    options,
  );
};

export const getGetPatientsSummaryQueryKey = (params?: GetPatientsSummaryParams) => {
  return [`/api/summary/patients`, ...(params ? [params] : [])] as const;
};

export const getGetPatientsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatientsSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientsSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsSummary>>> = ({ signal }) =>
    getPatientsSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsSummary>>>;
export type GetPatientsSummaryQueryError = ErrorType<unknown>;

export function useGetPatientsSummary<
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetPatientsSummaryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsSummary<
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatientsSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsSummary<
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatientsSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientsSummary<
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatientsSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientsSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientsSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatientsSummaryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientsSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsSummary>>> = ({ signal }) =>
    getPatientsSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsSummary>>>;
export type GetPatientsSummarySuspenseQueryError = ErrorType<unknown>;

export function useGetPatientsSummarySuspense<
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetPatientsSummaryParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsSummarySuspense<
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatientsSummaryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsSummarySuspense<
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatientsSummaryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientsSummarySuspense<
  TData = Awaited<ReturnType<typeof getPatientsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPatientsSummaryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSummary>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientsSummarySuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
